import React from 'react';
import { take, takeEvery, put, call, race, all } from 'redux-saga/effects';
import i18next from 'i18next';
import { Leave as LeaveIllustration } from '@wix/da-ds/pkg/Icons/Confirmations';
import { reduxModuleLoaded, updateNft, deleteNft } from './actions';
import { request } from '../../xhr';
import { isApiError } from '../../xhr/request';
import { putErrorNotification } from '../../utils/saga';
import { pushGlobalConfirmationModal, confirmYes, confirmNo, popModal } from '../../Modals/redux/actionCreators';
function* handleUpdateNft(action) {
    var _action;
    const { deviation, nft, nftData } = (_action = action) === null || _action === void 0 ? void 0 : _action.payload;
    const { deviationId } = deviation;
    const data = {
        deviationid: `${deviationId}`,
        blockchain: nftData.blockchainName,
        blockchain_identifier_primary: nftData.blockchainIdentifierPrimary,
        blockchain_identifier_secondary: nftData.blockchainIdentifierSecondary,
        link_to_marketplace: nftData.knownMarketplace,
        custom_marketplace_url: nftData.unknownMarketplace ? nftData.unknownMarketplaceLink : undefined
    };
    const response = yield call(request, {
        method: 'post',
        url: '/deviation/nft/update',
        data
    });
    // Dismiss the NftLinkPopup
    yield put(popModal());
    if (!response || isApiError(response) || !response.nft) {
        yield putErrorNotification(i18next.t('nft.linkPopup.error.update'));
        return;
    }
    if (nft) {
        const { nftId } = nft;
        if (!(nft.blockchainName === nftData.blockchainName && nft.blockchainIdentifierPrimary === nftData.blockchainIdentifierPrimary && nft.blockchainIdentifierSecondary === nftData.blockchainIdentifierSecondary)) {
            // For now, delete the old NFT as this is an update
            // Eventually, we do want to support multiple NFTs per deviation, but
            // that's a future-expansion thing
            const deleteData = {
                deviationid: `${deviationId}`,
                nftid: `${nftId}`
            };
            const deleteResponse = yield call(request, {
                method: 'post',
                url: '/deviation/nft/delete',
                data: deleteData
            });
            if (!deleteResponse || isApiError(deleteResponse) || !deleteResponse.success) {
                yield putErrorNotification(i18next.t('nft.linkPopup.error.delete'));
                return;
            }
        }
    }
    window.location.reload();
}
function* handleDeleteNft(action) {
    var _action;
    const { deviation, nft } = (_action = action) === null || _action === void 0 ? void 0 : _action.payload;
    const { deviationId } = deviation;
    const { nftId } = nft;
    yield put(pushGlobalConfirmationModal({
        titleTransKey: 'nft.linkPopup.deleteConfirmation.title',
        textTransKey: 'nft.linkPopup.deleteConfirmation.text',
        cancelBtnLabelTransKey: 'nft.linkPopup.deleteConfirmation.button.cancel',
        confirmBtnLabelTransKey: 'nft.linkPopup.deleteConfirmation.button.delete',
        icon: /*#__PURE__*/ React.createElement(LeaveIllustration, null),
        closeOnConfirmation: false
    }));
    const { no } = yield race({
        yes: take(confirmYes),
        no: take(confirmNo)
    });
    // Dismiss the delete confirmation
    yield put(popModal());
    if (no) {
        return;
    }
    const data = {
        deviationid: `${deviationId}`,
        nftid: `${nftId}`
    };
    const response = yield call(request, {
        method: 'post',
        url: '/deviation/nft/delete',
        data
    });
    // Dismiss the NftLinkPopup
    yield put(popModal());
    if (!response || isApiError(response) || !response.success) {
        yield putErrorNotification(i18next.t('nft.linkPopup.error.delete'));
        return;
    }
    window.location.reload();
}
export default function* saga() {
    yield take(reduxModuleLoaded); // wait for redux to load
    yield all([
        takeEvery(updateNft, handleUpdateNft),
        takeEvery(deleteNft, handleDeleteNft)
    ]);
}
